/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { MotivoTariffaDTO } from './motivo-tariffa-dto';


export interface RiepilogoTariffaDTO { 
    costo_pasto?: number;
    esente_ora?: boolean;
    regola_in_altri_casi?: boolean;
    motivi?: Array<MotivoTariffaDTO>;
}

